<template>
    <!--
        作者：kmdshop
        时间：2020-06-01
        描述：插件中心-收款单-修改
      -->
      <el-dialog
      title="收款单"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
      style="height: 650px;"
    >
  
   <!-- 在Vue模板中直接绑定字段 -->
  <div class="min-h-screen" v-if="!loading">
    <div class="max-w-4xl mx-auto bg-white">
  
      <!-- 线下确认支付 -->
      <section class="bg-gray-50 rounded-xl p-6 mb-6 border border-gray-200"
      v-if="form.is_reconciliation == 0 && form.pay_status.value == 10"
      >
        <h2 class="text-xl font-semibold mb-4 text-gray-800">线下支付确认</h2>
        <div >
          <div class="space-y-2">
            <label class="block text-sm font-medium text-gray-700">实付金额</label>
            <div class="relative" style="font-size: 16px;">
              {{ form.pay_price }}
            </div>
  
  
      
  
            <label class="flex items-center gap-2">
                <input 
                  type="radio" 
                  :checked="type === 20" 
                  @change="paytypeClick(20)"
                  class="form-radio h-4 w-4 text-blue-600"
               
                >
                <span class="text-sm">微信支付</span>
              </label>
              <label class="flex items-center gap-2">
                <input 
                  type="radio" 
                  :checked="type === 50" 
                    @change="paytypeClick(50)"
                  class="form-radio h-4 w-4 text-blue-600"
               
                >
                <span class="text-sm">银行卡支付</span>
              </label>
              <label class="flex items-center gap-2">
                <input 
                  type="radio" 
                  :checked="type === 40" 
                      @change="paytypeClick(40)"
                  class="form-radio h-4 w-4 text-blue-600"
               
                >
                <span class="text-sm">支付宝支付</span>
              </label>
  
  
              <!-- 银行卡支付 -->
          <span v-if="form.pay_type.value == 140  && form.pay_status.value == 10">
            <div class="relative" style="font-size: 16px;margin-top: 10px;" v-if="type == 40">
              <el-input placeholder="姓名：" 
              :rules="[{required: true,message: '请填写姓名'}]"
              v-model="form.pay_setting.zfb_name">
               
              </el-input>
            </div>
  
            <div class="relative" style="font-size: 16px;margin-top: 10px;" v-if="type == 40">
              <el-input placeholder="支付宝账户"
                :rules="[{required: true,message: '请填写支付宝账户'}]"
              v-model="form.pay_setting.zfb_account">
               
              </el-input>
            </div>
  
          </span>
          <!-- 微信支付 -->
          <span v-if="form.pay_type.value == 140  && form.pay_status.value == 10">
            <div class="relative" style="font-size: 16px;margin-top: 10px;" v-if="type == 20">
              <el-input placeholder="姓名：" 
              :rules="[{required: true,message: '请填写姓名'}]"
              v-model="form.pay_setting.wx_name">
               
              </el-input>
            </div>
  
            <div class="relative" style="font-size: 16px;margin-top: 10px;" v-if="type == 20">
              <el-input placeholder="微信账户"
                :rules="[{required: true,message: '请填写微信账户'}]"
              v-model="form.pay_setting.wx_account">
               
              </el-input>
            </div>
  
          </span>
          <!-- 支付宝支付 -->
          <span v-if="form.pay_type.value == 140 && form.pay_status.value == 10">
            <div class="relative" style="font-size: 16px;margin-top: 10px;"  v-if="type == 50">
              <el-input placeholder="姓名："
              :rules="[{required: true,message: '请填写姓名'}]"
              v-model="form.pay_setting.bank_name">
               
              </el-input>
            </div>
  
            <div class="relative" style="font-size: 16px;margin-top: 10px;"  v-if="type == 50">
              <el-input placeholder="银行信息：" 
              :rules="[{required: true,message: '请填写银行信息'}]"
              v-model="form.pay_setting.bank_account">
               
              </el-input>
            </div>
  
            <div class="relative" style="font-size: 16px;margin-top: 10px;"  v-if="type == 50">
              <el-input placeholder="银行卡号："
              :rules="[{required: true,message: '请填写银行卡号'}]"
              v-model="form.pay_setting.bank_card">
               
              </el-input>
            </div>
            
          </span>
  
  
      
          
          </div>
        
  
     
          <el-button type="primary"
          style="margin-top: 20px;float: right;"
          size="small" @click="confirmpay()" :loading="loading">确 定</el-button>
  
          <el-button 
          style="margin-top: 20px;float: right;margin-right: 20rpx;"
          size="small" @click="cancelFunc()" :loading="loading">取 消</el-button>
  
      
          <div style="clear: both;"> </div>
        </div>
      </section>
  

    </div>
  </div>
  
  
  </el-dialog>
    
  </template>
  
  <script>
  import Payment_receiptApi from '@/api/payment_receipt.js';
  
  export default {
    components: {
    },
    data() {
      return {
        // 直接从接口获取的原始数据
        form:{
          new_price:0,
          pay_setting:{
            wx_name:"",
            wx_account:"",
            zfb_name:"",
            zfb_account:"",
            bank_name:"",
            bank_account:"",
            bank_card:"",
          }
        }, 
        loading:false,
        type:20,
      };
    },
    created() {
      console.log(11111)
      this.dialogVisible = this.open_add;
      this.getDetail();
    },
    props: ["open_add","order_id"],
    methods: {
      paytypeClick(type){
        this.type = type;
      },
      confirmpay(){
        let self = this;
        let form = self.form;
          self
            .$confirm('线下是否已转账, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
         
              form.order_id = self.order_id;
             form.pay_setting.type = self.type;
              self.loading = true;
                  Payment_receiptApi.confirmpay(form, true)
                    .then(data => {
                      self.loading = false;
                      self.$message({
                        message: data.msg,
                        type: 'success'
                      });
                      self.dialogFormVisible("error")
                    })
                    .catch(error => {
                      self.loading = false;
                    });
            })
      },
      confirm(){
        let self = this;
        let form = self.form;
          self
            .$confirm('对账之后不再支持对账, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
         
              form.order_id = self.order_id;
  
              self.loading = true;
                  Payment_receiptApi.confirm(form, true)
                    .then(data => {
                      self.loading = false;
                      self.$message({
                        message: data.msg,
                        type: 'success'
                      });
                      self.dialogFormVisible("error")
                    })
                    .catch(error => {
                      self.loading = false;
                    });
            })
    
      },
   
   
  
     
       /*关闭弹窗*/
       dialogFormVisible(result) {
        this.$emit("close", {});
      },
      cancelFunc(){//取消
        this.dialogFormVisible("error")
      },
      getDetail() {
        let self = this;
        // 取到路由带过来的参数
        Payment_receiptApi.detail({order_id: self.order_id},true).then(res => {
            self.form = res.data;
            self.loading = false;
            self.$set(self.form, 'new_price', Number(self.form.pay_price))
            self.$forceUpdate()
          })
          .catch(error => {});
      },
      /*取消修改，返回任务列表*/
      cancelFunc() {
        this.$emit("close", { openDialog: false,"type":"" });
      },
      openProductUpload: function (code) {
        this.isProductUpload = true;
        this.code = code
      },
  
    
      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if(this.code == 'album'){
          if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });
  
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
  
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
        }else{
          if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });
  
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
  
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
        }
        
        this.isProductUpload = false;
      },
  
      /*删除商品图片*/
      deleteImg(index,code) {
        if(code == 'album'){
          this.form.image.splice(index, 1);
        }else if(code == 'bannar'){
          this.form.bannar.splice(index, 1);
        }
        
      },
    }
  };
  </script>
  
  <style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  .ql-editor {
    height: 400px;
  }
  
  
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  padding: 4px;
  }
  .receipt-form__field {
  margin-bottom: 1.5rem;
  }
  .receipt-form__label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/views/order/order/dialog/pay.vue